import { IChapter } from 'models/IChapter';
import React from 'react';
import { StyledChapter } from './Chapter.styled';
import { StrategyExerciseChoose } from 'components/StrategyExercises/StrategyExerciseChoose/StrategyExerciseChoose';
import { StrategyExercisePlan } from 'components/StrategyExercises/StrategyExercisePlan/StrategyExercisePlan';
import { StrategyExerciseStrength } from 'components/StrategyExercises/StrategyExerciseStrength/StrategyExerciseStrength';
import { StrategyExerciseControl } from 'components/StrategyExercises/StrategyExerciseControl/StrategyExerciseControl';
import { StrategyExerciseBreathe } from 'components/StrategyExercises/StrategyExerciseBreathe/StrategyExerciseBreathe';
import { IExerciseChoose } from 'models/exercises/IExerciseChoose';
import { IExercisePlan } from 'models/exercises/IExercisePlan';
import { IExerciseStrength } from 'models/exercises/IExerciseStrength';
import { IExerciseControl } from 'models/exercises/IExerciseControl';
import { STRATEGY_EXERCISE_TYPE } from '../../constants';
import { useNavigate } from 'react-router-dom';

interface ChapterProps {
    chapter: IChapter
}

export const Chapter: React.FC<ChapterProps> = ({ chapter }) => {
    const navigate = useNavigate();
    let content;

    const onComplete = () => {
      //TODO: do intro + outro screens, maybe put this code elsewhere
      document.startViewTransition(() => {
        navigate(`/chapter/${chapter.chapterIdentifier}/summary`);
      });
    };  
    switch (chapter.exerciseType) {
      case STRATEGY_EXERCISE_TYPE.Choose:
        content = <StrategyExerciseChoose onComplete={onComplete} strategyExerciseChoose={chapter.exercise as IExerciseChoose} />;
        break;
      case STRATEGY_EXERCISE_TYPE.Plan:
        content = <StrategyExercisePlan onComplete={onComplete} />
        break;
      case STRATEGY_EXERCISE_TYPE.Strengths:
        content = <StrategyExerciseStrength onComplete={onComplete} strategyExerciseStrength={chapter.exercise as IExerciseStrength} />;
        break;
      case STRATEGY_EXERCISE_TYPE.Control:
        content = <StrategyExerciseControl onComplete={onComplete} strategyExerciseControl={chapter.exercise as IExerciseControl} />
        break;
      case STRATEGY_EXERCISE_TYPE.Breathe:
        content = <StrategyExerciseBreathe chapter={chapter} onComplete={onComplete} />
        break;
    } 

    return <StyledChapter>
        {content}
    </StyledChapter>
}